var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.discordProfile)?_c('div',{staticClass:"discord-user"},[_c('img',{attrs:{"src":_vm.profileImage}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.discordProfile.username))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }